var _style, _rect, _rect2, _defs, _defs2, _defs3, _rect3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgVulnerability(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 36.71 33.8",
    style: {
      enableBackground: "new 0 0 36.71 33.8"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill-rule:evenodd;clip-rule:evenodd;fill:none;}\n\t.st1{fill:none;}\n\t.st2{enable-background:new    ;}\n\t.st3{clip-path:url(#SVGID_00000091736527234803565540000012609349573168270737_);}\n\t.st4{clip-path:url(#SVGID_00000049195921767201492750000011726589394587202971_);}\n\t.st5{clip-path:url(#SVGID_00000128443165144563061420000009940514710856196993_);fill:#FFFFFF;}\n")), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: -443.65,
    y: -233.9,
    className: "st0",
    width: 1680,
    height: 1080
  })), /*#__PURE__*/React.createElement("image", {
    style: {
      overflow: "visible"
    },
    width: 38,
    height: 34,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACcAAAAjCAYAAAAXMhMjAAAACXBIWXMAABJ0AAASdAHeZh94AAAD 5klEQVRYhc3YTYiWVRQH8N8d58OxMRxU8iMkcZELlUKRPiDD8gMi1KRcuwla1D5oGbQNghZtWrQp IsGIYhSkhHRRYFSOughERXFIxM/RGcfT4jnv8M404/s+71R24MLznHvOuf/3PPf877kv/2Mpcw0Q EV14FPNTdQfXSyn35xp7TuAiogdPYD82pfpnfIqzpZTxhwIuIrqxDm9jDD/m1PPoxUf4vZRy7z8F FxEFK/A+LuETXM7px/AmluM9XCylRCfrdHXihH68jEF8hvOllNFSyijOp24wbfo7XKM+uCyAldiN gzhXSplozOfzuZzbjZXp8++Dw8Jc9AYO4/YMNrdz7kbaLuwEXC2JiO6I2BQRQxHxSkT0Nc11NWco IvrSZih9uuuu13bmsggG8QZO4ieMRUSJiAGswZqIGEjbsbQ5mT6Dqf/nJSJ6I2JHRByKiGcamYiI BRGxP/WH8nlBznWn7eH07a2zZluZy1+8FPvwPU438dcj2I7Pc2xPnbQ5nT77sLRO9tr9rP3YiiU4 gOtNc90J/GyOpalryHV8lb5b1aCWluByk6/AHnyt4rTp52YX7ueYEjNtz6fvHqxol1raMVqIXSp6 GDIzdbSSZt9d2qSWB4KLiHmqKtyGLzHSyVGUPiMZY5uqqud1DC437iK8jjM4rqKHTmUsY5zJmIta FceDMteDp7ERX+Bqpwc4k9m7mrE2Zuye2uDyFy1Wlf9RnJprb5YAx3EqY+7D4gdlb7bMzceLWKai jmtzBdYk1zLmslxj/myGfwOXZb4ce/GNquto1XJPqLitO59nlYx1LmPvxfLZqGUm5QBeVW3g73Cr BbBxXFB1xevyudUWuJWxx3KtgZbgsrxXY6f2qeOmqnfbkuNg6maVadSyE6tnopbpbUyDOv5Qlf3d FsCkzRBO5PtIDb/jeCnXvIArzQbN/VcPNmCz6gC/0iZ1FNVnaXzWAW3cTTL2lVxrMzYkhklptD3N 1HEMwzWoYwBv4YV8P4oPTW0OZgM4HhHDueY+nIqIy42kNDLXh2exStVB1KGOPqzHtznWp65duZZr rkoMk74NcP2q++YR0y4sbcgYhrEjx7Aax1zThegIntPUUjUKohdrcQijNYBRXWI+xi/5fix1dWQU v+KdxDIFXKj+4xhQ80ZWSrkfESMq3oK7HZzBXarueTSxTAF3J5FvwYmIuKQ1kU6Xhn1XRC1sPaoT aQt+SyzIkk8CXIt38Sd+UHWvdfZeJzIPj6vO2CX4QHU/mZgElwB78SRew1Oq1rxlQzhHmcBF1X49 gDOllMlimkKWmcEBVadQ+xLcodxTfcqbNVni4cpfP3mfLrSPFdkAAAAASUVORK5CYII=",
    transform: "matrix(0.6006 0 0 0.6006 7.1109 6.704)"
  }), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 7.11,
    y: 6.7,
    className: "st1",
    width: 22.82,
    height: 20.42
  })), /*#__PURE__*/React.createElement("g", {
    className: "st2"
  }, /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_1_",
    x: 7.71,
    y: 7.3,
    width: 21.62,
    height: 19.22
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000110459787989629851000000010313149281150093474_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000110459787989629851000000010313149281150093474_)"
    }
  }, _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000010991806175290417400000001409266746516224148_",
    d: "M27.83,24.95c-0.15,0.28-0.38,0.51-0.65,0.67 c-0.27,0.16-0.58,0.24-0.9,0.24H10.76c-0.64,0-1.23-0.35-1.55-0.91c-0.32-0.56-0.32-1.25,0-1.81l7.76-13.65 c0.21-0.37,0.54-0.65,0.94-0.8c0.39-0.15,0.83-0.15,1.22,0c0.39,0.15,0.73,0.43,0.94,0.8l7.76,13.65 c0.16,0.27,0.25,0.59,0.25,0.91C28.08,24.36,28,24.67,27.83,24.95L27.83,24.95z M28.41,22.8L20.64,9.15 c-0.29-0.51-0.74-0.89-1.28-1.09c-0.54-0.2-1.13-0.2-1.67,0c-0.54,0.2-0.99,0.59-1.28,1.09L8.64,22.8 c-0.44,0.77-0.44,1.72,0,2.48c0.44,0.77,1.24,1.24,2.12,1.24h15.53c0.87,0,1.68-0.47,2.12-1.24 C28.84,24.51,28.84,23.57,28.41,22.8L28.41,22.8z M18.53,23.13h-0.02c-0.27,0-0.49-0.22-0.49-0.49c0-0.27,0.22-0.49,0.49-0.49 h0.02c0.27,0,0.49,0.22,0.49,0.49C19.02,22.91,18.8,23.13,18.53,23.13z M18.53,21.47h-0.02v0c-0.41,0-0.79,0.22-0.99,0.58 c-0.2,0.36-0.2,0.8,0,1.16c0.2,0.36,0.58,0.58,0.99,0.58h0.02c0.41,0,0.79-0.22,0.99-0.58c0.2-0.36,0.2-0.8,0-1.16 C19.32,21.69,18.94,21.47,18.53,21.47L18.53,21.47z M19.02,19.41c0,0.14-0.05,0.27-0.14,0.36c-0.09,0.1-0.22,0.15-0.35,0.15 c-0.13,0-0.26-0.05-0.35-0.15c-0.09-0.1-0.14-0.23-0.14-0.36v-5.68c0-0.14,0.05-0.27,0.14-0.36c0.09-0.1,0.22-0.15,0.35-0.15 c0.13,0,0.26,0.05,0.35,0.15c0.09,0.1,0.14,0.23,0.14,0.36V19.41z M18.52,12.56c-0.31,0-0.6,0.12-0.82,0.34 c-0.22,0.22-0.34,0.52-0.34,0.83v5.68c0,0.31,0.12,0.61,0.34,0.83c0.22,0.22,0.51,0.34,0.82,0.34c0.31,0,0.6-0.12,0.82-0.34 c0.22-0.22,0.34-0.52,0.34-0.83v-5.68c0-0.31-0.12-0.61-0.34-0.83C19.12,12.68,18.83,12.56,18.52,12.56L18.52,12.56z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000130632711466247623450000012021742676939645861_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000010991806175290417400000001409266746516224148_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000130632711466247623450000012021742676939645861_)"
    }
  }, _defs3 || (_defs3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000125590691867969674970000015433352861584042372_",
    x: 7.71,
    y: 7.3,
    width: 21.62,
    height: 19.82
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000148622069767481241240000015861004100631994761_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000125590691867969674970000015433352861584042372_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 7.6,
    y: 7.25,
    style: {
      clipPath: "url(#SVGID_00000148622069767481241240000015861004100631994761_)",
      fill: "#FFFFFF"
    },
    width: 21.84,
    height: 19.87
  }))))), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: -443.65,
    y: -233.9,
    className: "st0",
    width: 1680,
    height: 1080
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVulnerability);
export default __webpack_public_path__ + "static/media/vulnerability.2ed71e2f257087cd43f50a8da3375f2a.svg";
export { ForwardRef as ReactComponent };